/**
 * Seleção de tema de marca em build/deploy-time.
 *
 * O tema ativo é definido por REACT_APP_BRAND_THEME (default: "ecompay").
 * Os arquivos de tema (themes/<marca>.css) escopam seus primitivos sob
 * :root[data-theme="<marca>"]; aqui apenas marcamos qual está ativo no <html>.
 *
 * Para trocar a marca: defina REACT_APP_BRAND_THEME no .env e garanta que
 * themes/<marca>.css exista e esteja importado em App.js.
 */

export const DEFAULT_BRAND_THEME = "ecompay";

export function getBrandTheme() {
  return process.env.REACT_APP_BRAND_THEME || DEFAULT_BRAND_THEME;
}

export function applyBrandTheme() {
  if (typeof document === "undefined") return;
  document.documentElement.setAttribute("data-theme", getBrandTheme());
}
